<div class="logEntry">
  <p-panel [ngClass]="{'incommingMessage': displayData.isIncoming, 'outgoingMessage': !displayData.isIncoming}"
           [styleClass]="displayData.contentString || displayData.linkUrl || displayData.displayProperties ? 'communicationContent' : 'noContent'"
           [header]="displayData.title" headingLevel="h3">
    @if (displayData.linkUrl) {
    <div>
      <a [href]="displayData.linkUrl" target="_blank">
        @if (displayData.hasDownload) {
        <span class="iconfont-download_mono">&nbsp;</span>
        }
        {{ displayData.hasDownload? 'Download' : (displayData.contentString || displayData.title) }}
      </a>
    </div>
    }

    @if (displayData.displayProperties) {
    <dl class="displayProperties">
      @for (property of displayData.displayProperties; track property) {
      <dt>{{ property.key }}</dt>
      <dd>{{ property.value }}</dd>
      }
    </dl>
    }

    @if (displayData.contentString && !displayData.linkUrl) {
    <div>{{ displayData.contentString }}</div>
    }
    <ng-template #icons>
      @if (displayData.editable) {
      <button
              type="button"
              hisImage="PENCIL"
              class="transparent"
              [title]="uiText.EDIT_X | hisUi: displayData.title"
              (click)="editEntry.emit(displayData.id)"></button>
      }

      @if (displayData.editable && displayData.deletable) {
      <img hisImage="HYPHEN" class="inlineicon"
           styleClass="spacerHyphenTable">
      }

      @if (displayData.deletable) {
      <button
              type="button"
              hisImage="DELETE"
              class="transparent"
              [title]="uiText.DELETE_X | hisUi: displayData.title"
              (click)="deleteEntry.emit(displayData.id)"></button>
      }
    </ng-template>
    <p-footer>
      <span class="creationDate">
        {{ displayData.createdAt | hisDate: (uiText.DATE_TIME_FORMAT | hisUi) }}
      </span>
      <span class="senderName">
        {{ uiText.COMMUNICATION_LOG_ENTRY_FROM | hisUi }}: {{ displayData.senderName }}</span>
      <div class="clearer"></div>
      <span class="entryDomainChips"> {{ uiText.COMMUNICATION_LOG_ENTRY_DOMAINS | hisUi }}:
        @for (domain of displayData.domains; track domain) {
        <p-chip>
          <span>
            {{ domain.longtext || domain.uniquename }}
          </span>
        </p-chip>
        }
      </span>
    </p-footer>
  </p-panel>
</div>